import { expandMsTokens } from './expandMsTokens';
import { normalizeTokens } from './normalizeTokens';
import { plain } from './Plain';
import { repeat } from './Repeat';
import { GridTemplateInputToken } from './types';

/**
 * Create a template string for MS IE 11's grid spec.
 *
 * These templates require accounting for inserted columns and rows to simulate the "gap" property
 * supported by the newer specification.
 *
 * @param count The number of cells in the row or column
 * @param tokens The tokens describing how the cells should be sized
 * @param gap The distance between cells
 */
export function buildMsTemplate(
  count: number,
  tokens?: GridTemplateInputToken[],
  gap?: string | null,
) {
  const normalizedTokens = normalizeTokens(tokens);
  const safeTemplate = normalizedTokens.length ? normalizedTokens : [repeat(count, [plain('1fr')])];

  return expandMsTokens(safeTemplate, gap);
}
